import React from 'react';

class SubmitResult extends React.Component{
    render(){
        return (
            <div className="submit-result">
                    <svg xmlns="http://www.w3.org/2000/svg" className="result-svg" viewBox="0 0 70 70">
                        <g fill="none" fillRule="evenodd">
                            <circle cx="35" cy="35" r="35" fill="#7FC25D"/>
                            <path fill="#FFF" d="M19.432 39.974c-1.273-1.457-1.204-3.752.154-5.125l-.272.275c1.359-1.373 3.67-1.485 5.162-.249l10.006 8.287c1.492 1.236 1.6 3.352.248 4.72l-1.997 2.02c-1.355 1.371-3.485 1.302-4.76-.156l-8.54-9.772z"/>
                            <path fill="#FFF" d="M52.62 28.899c1.314-1.418 1.276-3.673-.087-5.04l.422.423c-1.361-1.366-3.61-1.406-5.027-.084L27.55 43.2c-1.415 1.32-1.407 3.457.005 4.764l1.41 1.304a3.507 3.507 0 0 0 4.946-.191l18.708-20.18z"/>
                        </g>
                    </svg>
                <p className="result-tip">{this.props.message || $st('表单提交成功')}</p>
            </div>
        )
    }
}
export default SubmitResult;


// WEBPACK FOOTER //
// ./src/component/SubmitResult.js